import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalUtils } from '../utils/modal-utils';
import { Injector } from '@angular/core';
import { ConfirmationModalComponent } from '../modules/confirmation/confirmation-modal/confirmation-modal.component';
import { ConfirmationOptions } from '../models/shared/stylesheet/confirmation-options';

export class ModalAbandon {
  static open(ngbModal: NgbModal, injector: Injector, confirmationOpts: ConfirmationOptions): Promise<boolean> {
    const modalRef = ngbModal.open(ConfirmationModalComponent, ModalUtils.confirmationModalOptions(injector));
    const compInstance = modalRef.componentInstance as ConfirmationModalComponent;
    compInstance.setConfirmationOptions(confirmationOpts);
    return modalRef.result;
  }
}
